import axios from "@/axios.js";
import constants from "@/constants.js";

export default {
  async createIntegrationLink({ commit }, playload) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/mergedev/integration/magic-link`,
        playload
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchActiveIntegration({ commit }, orgId) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/mergedev/integration/linked-accounts/${orgId}`
      );
      commit("SET_ACTIVE_INTEGRATION", resObj.data.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
};
